import { APP } from 'src/Configs/App'
import { Roles } from 'src/Constants/enums'
import { rtkApi } from 'src/Services/rtkApi'
import { CuratorUserMetaData, UsersMeResponse } from 'src/Types/users'

export type { UsersMeResponse }

export const userInfoApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    usersMe: builder.query<UsersMeResponse, void>({
      query: () => `${APP.TIKTOK_SERVER}/private/users/me`,
      providesTags: ['UsersMe'],
    }),
    acceptPreReleaseRules: builder.mutation<string, void>({
      query: () => ({
        url: `${APP.TIKTOK_SERVER}/curator/users/me/accept-pre-release-rules`,
        method: 'POST',
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['UsersMe'],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        const result = await queryFulfilled.catch(() => null)

        if (!result) {
          return
        }

        dispatch(
          userInfoApi.util.updateQueryData('usersMe', void 0, (draft) => {
            const metaData =
              draft.role === Roles.curator
                ? (draft.metaData as CuratorUserMetaData | null)
                : null

            if (metaData) {
              metaData.preReleaseRulesAcceptedAt = new Date().toISOString()
            }
          }),
        )
      },
    }),
  }),
})

export const { useUsersMeQuery, useAcceptPreReleaseRulesMutation } = userInfoApi

export const refetchUsersMe = (): ReturnType<
  typeof userInfoApi.endpoints.usersMe.initiate
> =>
  userInfoApi.endpoints.usersMe.initiate(void 0, {
    forceRefetch: true,
    subscribe: false,
  })
